import { useTranslation } from 'react-i18next'
import { IQuestion } from 'models/evaluation.model'
import { Wrapper, Title, Tags } from './styled'

interface IProps {
  question: IQuestion
  isReviewing: boolean
  index: number
}

export const QuestionTitle = ({ question, isReviewing, index }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix = 'lessons.contentBlocks.evaluation'

  return (
    <Wrapper>
      <Title>{`${index + 1}. ${question.text}`}</Title>
      <Tags correct={question.userAnswer?.correct === true}>
        <span>
          {`${question.score} ${t(
            `${translationPrefix}.${question.score > 1 ? 'points' : 'point'}`
          )}`}
        </span>
        {isReviewing && (
          <span>
            {t(
              `${translationPrefix}.${
                question.userAnswer?.correct === true ? 'correct' : 'incorrect'
              }`
            )}
          </span>
        )}
      </Tags>
    </Wrapper>
  )
}

export default QuestionTitle
